import type { SxProps, Theme } from '@mui/material';

export const sectionHeaderSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '0.75rem',
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  mt: 2,
  mb: 0.5,
};

export const sectionBoxSx: SxProps<Theme> = {
  mb: 1.5,
};

export const labelValueRowSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  py: 0.25,
  minWidth: 0,
};

export const labelSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.8rem',
  minWidth: 100,
  flexShrink: 0,
};

export const valueSx: SxProps<Theme> = {
  fontSize: '0.85rem',
  fontWeight: 500,
  textAlign: 'right',
  flex: 1,
  ml: 1,
  minWidth: 0,
};
